import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=faa08444&"
import script from "./FormUpload.vue?vue&type=script&lang=js&"
export * from "./FormUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports